import { useEffect, useState } from 'react';

import { axiosPrivateInstance } from 'libs/axios';
import { GET_ALL_L4_SYSTEM_BY_ID } from 'utils/serviceUrls';
import { useAppDispatch } from 'hooks/stateHooks';
import { useTranslation } from 'react-i18next';
import { setMessage, setNotificationType, setShowNotification } from 'slices/roleModuleSlice';

const useGetL4SystemById = (l4ById: any) => {
	const { t } = useTranslation('l4System');
	const dispatch = useAppDispatch();
	const [l4Loading, setL4Loading] = useState<boolean>(false);
	const [resData, setResData] = useState<any>();

	useEffect(() => {
		if (l4ById !== 0) {
			setL4Loading(true);
			axiosPrivateInstance
				.post(GET_ALL_L4_SYSTEM_BY_ID, { encSystemID: l4ById })
				.then((response: any) => {
					if (response?.output && response?.status) {
						setResData(response?.output);
					} else {
						dispatch(setMessage(t('SOMETHING_WENT_WRONG')));
						dispatch(setShowNotification(true));
						dispatch(setNotificationType('error'));
					}
				})
				.catch(() => {
					dispatch(setMessage(t('SOMETHING_WENT_WRONG')));
					dispatch(setShowNotification(true));
					dispatch(setNotificationType('error'));
				})
				.finally(() => {
					setL4Loading(false);
				});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [l4ById]);

	return {
		l4Loading,
		resData,
	};
};

export default useGetL4SystemById;
